import React from 'react'
import PropTypes from 'prop-types'
import Form from 'react-bootstrap/Form'
import { Button, Col } from 'react-bootstrap'
import '../InputDomicilio.css'
import InputGroup from 'react-bootstrap/InputGroup'
import SelectActividades from '../SelectActividades'
import ActividadesSecundarias from './ActividadesSecundarias'

const ListadoDomiciliosHooks = (props) => {
  const idElemento = (controlId) => controlId + controlId
  return (
    <>
      {props.listado?.map((dato, index) => {
        return (
          <div className="input-domicilio" key={dato?.id}>
            <Form.Row>
              <Col md={6}>
                <InputGroup>
                  <Form.Group controlId={idElemento('formCalle') + index}>
                    <Form.Label>Calle (Domicilio {index + 1})</Form.Label>
                    <Form.Control
                      type="text"
                      defaultValue={dato.calle}
                      isInvalid={
                        !!props.errors?.[props.donde]?.domicilioComercial?.[
                          index
                        ]?.calle
                      }
                      isValid={
                        !props.errors?.[props.donde]?.domicilioComercial?.[
                          index
                        ]?.calle &&
                        props.getValues(`${props.nombre}[${index}].calle`)
                      }
                      ref={props.register({ required: true })}
                      disabled={props.isDisabled}
                      placeholder="Ingrese la Calle"
                      name={`${props.nombre}[${index}].calle`}
                    />
                    <Form.Control.Feedback>
                      {!!props.errors?.[props.donde]?.domicilioComercial?.[
                        index
                      ]?.calle && 'El cambio es obligatorio'}
                    </Form.Control.Feedback>
                    {!props.isDisabled && (
                      <InputGroup.Append>
                        <span className="input-group-btn material-icons">
                          <button
                            type="button"
                            onClick={() => props.remove(index)}
                          >
                            <i className="material-icons delete" />
                          </button>
                        </span>
                      </InputGroup.Append>
                    )}
                  </Form.Group>
                </InputGroup>
              </Col>
              <Col md={6}>
                <Form.Row>
                  <Col md={4}>
                    <Form.Group
                      controlId={idElemento('formNumeroCalle') + index}
                    >
                      <Form.Label>Numero </Form.Label>
                      <Form.Control
                        type="number"
                        defaultValue={dato.numero}
                        isInvalid={
                          !!props.errors?.[props.donde]?.domicilioComercial?.[
                            index
                          ]?.numero
                        }
                        isValid={
                          !props.errors?.[props.donde]?.domicilioComercial?.[
                            index
                          ]?.numero &&
                          props.getValues(`${props.nombre}[${index}].numero`)
                        }
                        ref={props.register({ required: true })}
                        placeholder="Número"
                        disabled={props.isDisabled}
                        name={`${props.nombre}[${index}].numero`}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId={idElemento('formPiso') + index}>
                      <Form.Label>Piso </Form.Label>
                      <Form.Control
                        type="number"
                        defaultValue={dato.piso}
                        isInvalid={
                          !!props.errors?.[props.donde]?.domicilioComercial?.[
                            index
                          ]?.piso
                        }
                        isValid={
                          !props.errors?.[props.donde]?.domicilioComercial?.[
                            index
                          ]?.piso &&
                          props.getValues(`${props.nombre}[${index}].piso`)
                        }
                        ref={props.register()}
                        placeholder="Piso"
                        disabled={props.isDisabled}
                        name={`${props.nombre}[${index}].piso`}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group
                      controlId={idElemento('formCodigoPostal') + index}
                    >
                      <Form.Label>CP</Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue={dato.codigoPostal}
                        isInvalid={
                          !!props.errors?.[props.donde]?.domicilioComercial?.[
                            index
                          ]?.codigoPostal
                        }
                        isValid={
                          !props.errors?.[props.donde]?.domicilioComercial?.[
                            index
                          ]?.codigoPostal &&
                          props.getValues(
                            `${props.nombre}[${index}].codigoPostal`
                          )
                        }
                        ref={props.register({ required: true })}
                        placeholder="CP."
                        disabled={props.isDisabled}
                        name={`${props.nombre}[${index}].codigoPostal`}
                      />
                    </Form.Group>
                  </Col>
                </Form.Row>
              </Col>
              <Col md={6}>
                <Form.Group
                  controlId={idElemento('formPartidaDomiciliaria') + index}
                >
                  <Form.Label>Localidad</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={dato.localidad}
                    isInvalid={
                      !!props.errors?.[props.donde]?.domicilioComercial?.[index]
                        ?.localidad
                    }
                    isValid={
                      !props.errors?.[props.donde]?.domicilioComercial?.[index]
                        ?.localidad &&
                      props.getValues(`${props.nombre}[${index}].localidad`)
                    }
                    ref={props.register({ required: true })}
                    placeholder="Localidad"
                    disabled={props.isDisabled}
                    name={`${props.nombre}[${index}].localidad`}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group
                  controlId={idElemento('formPartidaDomiciliaria') + index}
                >
                  <Form.Label>Partida Inmobiliaria </Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={dato.partidaInmobiliaria}
                    isInvalid={
                      !!props.errors?.[props.donde]?.domicilioComercial?.[index]
                        ?.partidaInmobiliaria
                    }
                    isValid={
                      !props.errors?.[props.donde]?.domicilioComercial?.[index]
                        ?.partidaInmobiliaria &&
                      props.getValues(
                        `${props.nombre}[${index}].partidaInmobiliaria`
                      )
                    }
                    ref={props.register({ required: true })}
                    placeholder="Partida Inmobiliaria"
                    disabled={props.isDisabled}
                    name={`${props.nombre}[${index}].partidaInmobiliaria`}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId={'formHabilitacion-' + index}>
                  <Form.Label>
                    Habilitacion para Domicilio N°{index + 1}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={dato.habilitacion?.habilitacion}
                    isInvalid={
                      !!props.errors?.[props.donde]?.domicilioComercial?.[index]
                        ?.habilitacion?.habilitacion
                    }
                    isValid={
                      !props.errors?.[props.donde]?.domicilioComercial?.[index]
                        ?.habilitacion?.habilitacion &&
                      props.getValues(
                        `${props.nombre}[${index}].habilitacion.habilitacion`
                      )
                    }
                    ref={props.register({ required: true })}
                    name={`${props.nombre}[${index}].habilitacion.habilitacion`}
                    placeholder="Ingrese Numero de Habilitación"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group
                  controlId={'formHabilitacion-' + index + 'actividadPpal'}
                >
                  <Form.Label>
                    Actividad Principal para Domicilio N°{index + 1}
                  </Form.Label>
                  <SelectActividades
                    actividadesiibb={props.actividadesiibb}
                    defaultValue={dato.habilitacion?.actividadPrincipal}
                    isInvalid={
                      !!props.errors?.[props.donde]?.domicilioComercial?.[index]
                        ?.habilitacion?.actividadPrincipal
                    }
                    isValid={
                      !props.errors?.[props.donde]?.domicilioComercial?.[index]
                        ?.habilitacion?.actividadPrincipal &&
                      props.getValues(
                        `${props.nombre}[${index}].habilitacion.actividadPrincipal`
                      )
                    }
                    register={() => props.register({ required: true })}
                    name={`${props.nombre}[${index}].habilitacion.actividadPrincipal`}
                    isDisabled={props.isDisabled}
                  />
                </Form.Group>
              </Col>
              <ActividadesSecundarias
                listado={`${props.nombre}[${index}]`}
                isValid={() =>
                  props.errors?.[props.donde]?.domicilioComercial?.[index]
                    ?.habilitacion?.actividadSecundaria
                }
                getValues={props.getValues}
                actividadesiibb={props.actividadesiibb}
                isHabilitacion={true}
                isDisabled={props.isDisabled}
                control={props.control}
                nestIndex={index}
                register={props.register}
              />
            </Form.Row>
          </div>
        )
      })}
      {!props.isDisabled && (
        <Form.Row>
          <Col lg={6} sm={12} mt={4}>
            <Button
              className={'btn btn-block margin-top-1x margin-bottom-1x'}
              variant="outline-primary"
              onClick={() => props.append({})}
            >
              Agregar
            </Button>
          </Col>
        </Form.Row>
      )}
    </>
  )
}

ListadoDomiciliosHooks.propTypes = {
  isDisabled: PropTypes.bool,
  donde: PropTypes.string.isRequired,
  listado: PropTypes.array.isRequired,
  nombre: PropTypes.string.isRequired,
  append: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired
}

ListadoDomiciliosHooks.defaultProps = {
  isDisabled: false
}

export default ListadoDomiciliosHooks
